<template>
  <v-dialog id="dialog" v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" text class="primary--text">
        <v-icon small class="mr-1">mdi-server-plus</v-icon>
        Add Device
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Add new device</v-card-title>
      <v-card-text>
        <v-container fluid v-if="registrationTokens.length > 0">
          <v-row align="center">
            <v-select
              :items="registrationTokens"
              label="Registration Token"
              class="pr-4"
              v-model="selectedTokenID"
             :hint="`used by ${selectedToken.deviceCount} devices`"
              item-text="name"
              item-value="id"
              outlined
              dense
            ></v-select>
          </v-row>

          <v-row>
            <p>
              To register a new machine, run the following command on the device:
            </p>
          
          </v-row>

          <v-row align="center" class="mb-2 mt-4">

            <v-tabs v-model="tab" height="35px">
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-direct">Default</v-tab>
              <v-tab href="#tab-docker">Docker</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab" class="mt-4">
              <v-tab-item value="tab-direct">
                <markup language="bash" :code="installCommand" :inline="false"></markup>
              </v-tab-item>
              <v-tab-item value="tab-docker">
                <markup language="bash" :code="dockerInstallCommand" :inline="false"></markup>

                <p class="mt-3">
                  If you are using Windows WSL or MacOS, enable the "default Docker socket" in your Docker Desktop settings.
                  
                </p>
              </v-tab-item>
            </v-tabs-items>            
          </v-row>

        </v-container>

        <v-container fluid v-else >
          <v-row align="center">
            <pre>
              Please create at least one device registration token before provisioning.
            </pre>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn small text v-on:click.native="dialog = false" class="secondary--text">Close</v-btn>
        <v-spacer></v-spacer>  
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="stylus">
  .addbtn
    margin: 0px
    top: auto
    right: 20px
    bottom: 20px
    left: auto
    position: fixed
    z-index: 1
</style>

<script>
import Markup from '../helpers/Markup';

  export default {
    components: {
      Markup
    },
    data () {
      return {
        dialog: false,
        tab: 'tab-direct',
        selectedTokenID: ''
      }
    },

    computed: {
      loading() {
        return this.$store.state.device.loading
      },
      error() {
        return this.$store.state.device.error
      },
      projectId() {
        return this.$route.params.project
      },
      registrationTokens() {
        return this.$store.state.device.registrationTokens
      },
      selectedToken() {
        if (this.selectedTokenID === '' && this.registrationTokens.length > 0) {
          return this.registrationTokens[0]
        } 
        const selectedTokenId = this.selectedTokenID
        const found = this.registrationTokens.find(token => token.id === selectedTokenId)
        return found
      },    
      installCommand() {
        // some crappy formatting
        return `curl https://downloads.synpse.net/install.sh | \\\n  AGENT_PROJECT=${this.projectId} \\\n  AGENT_REGISTRATION_TOKEN=${this.selectedToken.id} \\\n  AGENT_CONTROLLER_URI=${window.location.protocol}//${window.location.host}/api \\\n  bash`
      },
      dockerInstallCommand() {
        // docker run -d \
        // --hostname agent-1 \
        // --name synpse-agent \
        // -v /var/run/docker.sock:/var/run/docker.sock \
        // -e AGENT_PROJECT=<prj_agent_project> \
        // -e AGENT_REGISTRATION_TOKEN=<drt_token_value> \
        // -v /data/etc-synpse:/etc/synpse \
        // -v /data/var-lib-synpse:/var/lib/synpse \
        // ghcr.io/synpse-hq/agent:latest
        // some crappy formatting
        return `docker run -d --hostname synpse-agent \\\n  --name synpse-agent \\\n  -v /var/run/docker.sock:/var/run/docker.sock \\\n  --network host \\\n  -e AGENT_PROJECT=${this.projectId} \\\n  -e AGENT_REGISTRATION_TOKEN=${this.selectedToken.id} \\\n  -e AGENT_CONTROLLER_URI=${window.location.protocol}//${window.location.host}/api \\\n  -v synpse-etc:/etc/synpse \\\n  -v synpse-var:/var/lib/synpse \\\n  ghcr.io/synpse-hq/agent:latest`
      }
    },

    methods: {
      refresh () {
        let q = {
          projectId: this.projectId
        } 
        this.$store.dispatch('ListDeviceRegistrationTokens', q)
      }
    }
  }
</script>
